import http, { expandURI } from '@/utils/ajax'
import { extractMenu, extractMessages } from '@/utils/extract'
import {
  SCHEME_INIT_SUCCESS,
  SCHEME_INIT_LOADING,
  SCHEME_INIT_FAIL,
  SCHEME_MENU_SUCCESS,
  SCHEME_MENU_LOADING,
  SCHEME_MENU_FAIL,
  PKGPLAN_MENU_SUCCESS,
  PKGPLAN_MENU_LOADING,
  PKGPLAN_MENU_FAIL,
  PKGRISK_MENU_SUCCESS,
  PKGRISK_MENU_LOADING,
  PKGRISK_MENU_FAIL,
  PKGRISKITEM_MENU_SUCCESS,
  PKGRISKITEM_MENU_LOADING,
  PKGRISKITEM_MENU_FAIL,
  STDRISKTEXT_MENU_SUCCESS,
  STDRISKTEXT_MENU_LOADING,
  STDRISKTEXT_MENU_FAIL,
  STDITEMTEXT_MENU_SUCCESS,
  STDITEMTEXT_MENU_LOADING,
  STDITEMTEXT_MENU_FAIL,
  PKGTARFBEN_MENU_SUCCESS,
  PKGTARFBEN_MENU_LOADING,
  PKGTARFBEN_MENU_FAIL,
  PKGTARFFACT_MENU_SUCCESS,
  PKGTARFFACT_MENU_LOADING,
  PKGTARFFACT_MENU_FAIL
} from '@/store/types'

export const scheme = {
  async schemeInit ({ commit, state }) {
    const apiUrl = state.menu.scheme
    commit(SCHEME_INIT_LOADING)
    if (apiUrl) {
      try {
        const result = await http.get(apiUrl)
        const menu = extractMenu(result.data._links)
        const commitResult = {
          menu: menu
        }
        commit(SCHEME_INIT_SUCCESS, commitResult)
      } catch (error) {
        commit(SCHEME_INIT_FAIL, extractMessages(error))
      }
    } else {
      commit(SCHEME_INIT_FAIL, extractMessages(['Invalid Api Url - Scheme Menu']))
    }
  },
  async schemeMenuInit ({ commit, state }, scheme) {
    const apiUrl = state.scheme.menu.schemeGet
    const expand = {
      scheme: scheme
    }
    if (apiUrl) {
      commit(SCHEME_MENU_LOADING)
      try {
        const result = await http.get(expandURI(apiUrl, expand))
        const menu = extractMenu(result.data._links)
        const commitResult = {
          data: result.data.data,
          menu: menu
        }
        commit(SCHEME_MENU_SUCCESS, commitResult)
      } catch (error) {
        commit(SCHEME_MENU_FAIL, extractMessages(error))
      }
    } else {
      commit(SCHEME_MENU_FAIL, extractMessages(['Invalid Api Url - Scheme Menu']))
    }
  },
  async pkgPlanMenuInit ({ commit, state }, expands) {
    const apiUrl = state.scheme.schemeMenu.menu.pkgPlan
    commit(PKGPLAN_MENU_LOADING)
    if (apiUrl) {
      try {
        const result = await http.get(expandURI(apiUrl, expands))
        const menu = extractMenu(result.data._links)
        const commitResult = {
          data: result.data.data,
          menu: menu
        }
        commit(PKGPLAN_MENU_SUCCESS, commitResult)
      } catch (error) {
        commit(PKGPLAN_MENU_FAIL, extractMessages(error))
      }
    } else {
      commit(PKGPLAN_MENU_FAIL, extractMessages(['Invalid Api Url - Package Plan Menu']))
    }
  },
  async pkgRiskMenuInit ({ commit, state }, expands) {
    const apiUrl = state.scheme.pkgPlanMenu.menu.pkgRisk
    commit(PKGRISK_MENU_LOADING)
    if (apiUrl) {
      try {
        const result = await http.get(expandURI(apiUrl, expands))
        const menu = extractMenu(result.data._links)
        const commitResult = {
          data: result.data.data,
          menu: menu
        }
        commit(PKGRISK_MENU_SUCCESS, commitResult)
      } catch (error) {
        commit(PKGRISK_MENU_FAIL, extractMessages(error))
      }
    } else {
      commit(PKGRISK_MENU_FAIL, extractMessages(['Invalid Api Url - Package Risk Menu']))
    }
  },
  async pkgRiskItemMenuInit ({ commit, state }, expands) {
    const apiUrl = state.scheme.pkgRiskMenu.menu.pkgRiskItemGet
    commit(PKGRISKITEM_MENU_LOADING)
    if (apiUrl) {
      try {
        const result = await http.get(expandURI(apiUrl, expands))
        const menu = extractMenu(result.data._links)
        const commitResult = {
          data: result.data.data,
          menu: menu
        }
        commit(PKGRISKITEM_MENU_SUCCESS, commitResult)
      } catch (error) {
        commit(PKGRISKITEM_MENU_FAIL, extractMessages(error))
      }
    } else {
      commit(PKGRISKITEM_MENU_FAIL, extractMessages(['Invalid Api Url - Package Risk Item Menu']))
    }
  },
  async stdRiskTxtMenuInit({ commit, state }, expands) {
    const apiUrl = state.scheme.schemeMenu.menu.pkgStdRiskTxtGet
    commit(STDRISKTEXT_MENU_LOADING)
    if (apiUrl) {
      try {
        const result = await http.get(expandURI(apiUrl, expands))
        const menu = extractMenu(result.data._links)
        const commitResult = {
          data: result.data.data,
          menu: menu
        }
        commit(STDRISKTEXT_MENU_SUCCESS, commitResult)
      } catch (error) {
        commit(STDRISKTEXT_MENU_FAIL, extractMessages(error))
      }
    } else {
      commit(STDRISKTEXT_MENU_FAIL, extractMessages(['Invalid Api Url - Package Risk Text Menu']))
    }
  },
  async stdItemTxtMenuInit({ commit, state }, expands) {
    const apiUrl = state.scheme.stdRiskTxtMenu.menu.pkgStdItemTxt
    commit(STDITEMTEXT_MENU_LOADING)
    if (apiUrl) {
      try {
        const result = await http.get(expandURI(apiUrl, expands))
        const menu = extractMenu(result.data._links)
        const commitResult = {
          data: result.data.data,
          menu: menu
        }
        commit(STDITEMTEXT_MENU_SUCCESS, commitResult)
      } catch (error) {
        commit(STDITEMTEXT_MENU_FAIL, extractMessages(error))
      }
    } else {
      commit(STDITEMTEXT_MENU_FAIL, extractMessages('Invalid Api Url - Package Risk Item Text Menu'))
    }
  },
  async pkgTarfBenMenuInit({ commit, state }, expands) {
    const apiUrl = state.scheme.schemeMenu.menu.pkgTarfBen
    commit(PKGTARFBEN_MENU_LOADING)
    if (apiUrl) {
      try {
        const result = await http.get(expandURI(apiUrl, expands))
        const menu = extractMenu(result.data._links)
        const commitResult = {
          data: result.data.data,
          menu: menu
        }
        commit(PKGTARFBEN_MENU_SUCCESS, commitResult)
      } catch (error) {
        commit(PKGTARFBEN_MENU_FAIL, extractMessages(error))
      }
    } else {
      commit(PKGTARFBEN_MENU_FAIL, extractMessages('Invalid Api Url - Package Tariff Benefit Menu'))
    }
  },
  async pkgTarfFactMenuInit({ commit, state }, expands) {
    const apiUrl = state.scheme.pkgTarfBenMenu.menu.pkgTarfFact
    commit(PKGTARFFACT_MENU_LOADING)
    if (apiUrl) {
      try {
        const result = await http.get(expandURI(apiUrl, expands))
        const menu = extractMenu(result.data._links)
        const commitResult = {
          data: result.data.data,
          menu: menu
        }
        commit(PKGTARFFACT_MENU_SUCCESS, commitResult)
      } catch (error) {
        commit(PKGTARFFACT_MENU_FAIL, extractMessages(error))
      }
    } else {
      commit(PKGTARFFACT_MENU_FAIL, extractMessages('Invalid Api Url - Package Tariff Benefit Menu'))
    }
  }
}
